import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {api} from "@shared/lib/axios/interceptor";
import {CommonDto} from "@shared/types/common-dto";
import {clearSession} from "@shared/utils/clear-session";
import { extractApiError } from "@shared/lib/api/extract-api-error";

const defaultErrorMessage = "An unexpected error occurred.";

export const useLogoutApi = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    const logoutApi = async () => {
        setLoading(true);
        setError(null);

        try {
            // 서버 로그아웃은 best-effort. 응답을 검사하지 않는다(로컬 정리는 finally 에서 무조건).
            await api.patch<CommonDto<null>>("/api/v3/accounts/logout");
        } catch (e) {
            // 네트워크/4xx/5xx 등 호출 실패는 로컬 로그아웃을 막지 않는다. error 상태만 갱신(현재 소비처 없음).
            setError(extractApiError(e, defaultErrorMessage));
        } finally {
            // 로그아웃은 사용자 의도 → 서버 응답과 무관하게 로컬 세션은 항상 정리 + 로그인 화면으로.
            // (D1: 공유 PC 토큰 잔존 방지. navigate 전에 setLoading(false) → unmount-후-setState 방지.)
            setLoading(false);
            // 스토리지 접근 예외(예: Safari 프라이빗 모드)가 navigate 를 막지 않도록 가드 — 로그인 이동은 항상 보장.
            try {
                clearSession();
            } catch {
                // 정리 실패해도 로그인 화면 이동은 진행한다.
            }
            navigate("/");
        }
    };

    return {logoutApi, loading, error};
};
